// @flow

import * as React from 'react';
import Relay from 'react-relay/classic';

import Link from './link';
import Icon from 'app/components/shared/Icon';
import Badge from 'app/components/shared/Badge';

// We use this constant to put a notice up when there's scheduled maintenance
// planned. 24 hours after the time has passed it'll be automatically hidden.
//
// Set the value to null if there's no planned maintenance.
//
// const scheduledMaintenance = null;
const scheduledMaintenance = {
  date: "14 Dec 2019 23:00:00 UTC",
  url: "https://www.buildkitestatus.com/incidents/1v0cwny4fcdg",
  hours: 1
};

type Props = {
  viewer?: {
    unreadChangelogs?: {
      count: number
    }
  },
  relay: Object
};

class Footer extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.relay.setVariables({ isMounted: true });
  }

  render() {
    let changelogBadge;
    // Viewer is not supplied when rendered for an anonymous user
    if (this.props.viewer && this.props.viewer.unreadChangelogs && this.props.viewer.unreadChangelogs.count > 0) {
      changelogBadge = (
        <span className="inline-block bg-dark-gray hover-lime-child white rounded ml1 small p1 line-height-1">{this.props.viewer.unreadChangelogs.count}</span>
      );
    }

    return (
      <footer className="container center" style={{ marginTop: 40, paddingTop: 30 }}>
        <div className="px2 border-top border-gray dark-gray">
          <div className="mt4 mb4 px2 small">
            <Link href="/home">Home</Link>
            <Link href="/changelog">
              <span>Changelog</span>{changelogBadge}
            </Link>
            <Link href="/docs">Docs</Link>
            <Link href="https://forum.buildkite.community/c/feature-requests">Feedback</Link>
            <Link href="/privacy-policy">Privacy</Link>
            <Link href="/terms-of-service">Terms</Link>
            <Link href="https://forum.buildkite.community/">Forum</Link>
            <Link href="https://buildkitestatus.com/">System Status</Link>
          </div>
          {this.renderScheduledMaintenance()}
          <div className="mt4 mb4">
            <a href="http://twitter.com/buildkite" className="btn hover-lime px1" title="Twitter icon"><Icon icon="twitter" /></a>
            <a href="https://github.com/buildkite" className="btn hover-lime px1" title="GitHub icon"><Icon icon="github" /></a>
          </div>
        </div>
      </footer>
    );
  }

  renderScheduledMaintenance() {
    if (!scheduledMaintenance) { return null; }

    const maintenanceDate = new Date(Date.parse(scheduledMaintenance.date));

    // Check how many hours past the event we are, and hide it if we've passed
    // the hoursToKeepUpNotice value.
    const hoursSinceMaintenance = (new Date() - maintenanceDate) / 1000 / 60 / 60;
    if (hoursSinceMaintenance > scheduledMaintenance.hours) { return null; }

    const formattedDate = maintenanceDate.toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'short',
      hour: 'numeric',
      timeZoneName: 'short'
    });

    return (
      <div className="mt4 mb4">
        <a href={scheduledMaintenance.url}>
          <Badge className="bg-dark-gray hover-bg-lime">
            {`Upcoming Scheduled Maintenance: ${formattedDate}`}
          </Badge>
        </a>
      </div>
    );
  }
}

export default Relay.createContainer(Footer, {
  initialVariables: {
    isMounted: false
  },

  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        unreadChangelogs: changelogs(read: false) @include(if: $isMounted) {
          count
        }
      }
    `
  }
});
